const HomeType = [
	{ value: "light" , label: "Emagrecimento", identifier:"light" }/*,
  { value: "moderado" , label: "Moderado", identifier:"moderado"  }*/,
	{ value: "hardcore" , label: "Hipertrofia", identifier:"hardcore"  }
];

export default HomeType;



// WEBPACK FOOTER //
// ./src/data/HomeType.js